import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'repuestosFilter',
    pure: false
})
export class RepuestosFilter implements PipeTransform {
    transform(items: any[], filter: String, estado: String): any {
        if (filter.length<1) return items.filter(item =>  (estado=="ALL" || item.status==estado ));
        
        filter = filter.toLocaleLowerCase();
        return items.filter(item =>  (estado=="ALL" || item.status==estado ) && item.tecnico_label.toLocaleLowerCase().indexOf(filter) !== -1 );
    }
}